import React from 'react';
import { SDescription, SLayout, SSubmitError, STitle, SVerifyRow, SVerifyText, SVerifyVal } from './ForgotPasswordPage.styles';
import { CustomButton } from 'components/CustomButton/CustomButton';
import TelephoneIcon from './TelephoneIcon';
import EmailIcon from './EmailIcon';

import { selectForgotPasswordData } from 'store/forgotPassword/forgotPassword.slice';
import { useSelector } from 'react-redux';
import { formatPhoneNumber } from 'utils/helpers/formatHelpers';
import { generatePath, useNavigate } from 'react-router-dom';
import { ROUTES } from 'constants/routes';
import { getResultData } from '../SmsCodePage/helpers';
import { ISmsCodeMutationResult } from 'types/smsCode.types';
import { useGenerateCodeMutation } from 'store/forgotPassword/forgotPassword.api';

export const ForgotPasswordPage: React.FC = () => {
  const { username, email, phone } = useSelector(selectForgotPasswordData);
  const [generateResult] = useGenerateCodeMutation();
  const generateStatus = getResultData(generateResult as ISmsCodeMutationResult);
  const navigate = useNavigate();

  const handleConfirm = () => {
    if (username) {
      navigate(generatePath(ROUTES.smsCode.path, { type: 'forgot-password' }), { state: { codeDelivery: email ? 'Email' : 'Phone' } });
    }
  };

  return (
    <SLayout>
      <STitle>Verification</STitle>

      <SDescription>For your security, a verification code will be sent to your registered {email ? 'email' : 'mobile number'} below to reset your password.</SDescription>

      <SVerifyRow>
        {email ? <EmailIcon /> : <TelephoneIcon />}

        <SVerifyText>
          {email ? 'Email' : 'Phone number'}: <SVerifyVal>{email || formatPhoneNumber(phone)}</SVerifyVal>
        </SVerifyText>
      </SVerifyRow>

      {generateStatus?.errorMessage && <SSubmitError>{generateStatus?.errorMessage}</SSubmitError>}

      <CustomButton type="primary" block buttonSize="large" htmlType="submit" onClick={handleConfirm} disabled={Boolean(generateStatus?.errorMessage) || (!email && !phone)}>
        Continue
      </CustomButton>
    </SLayout>
  );
}; 